export const queryKeys = {
  base: () => ['auto_updates'] as const,
};
